import {
  ApplicationConfig,
  importProvidersFrom, ImportProvidersSource,
  provideZonelessChangeDetection
} from '@angular/core';
import {provideRouter} from '@angular/router';

import {routes} from './app.routes';
import {provideEnvironmentNgxMask} from "ngx-mask";
import {provideHttpClient, withFetch, withInterceptors} from "@angular/common/http";
import {
  httpErrorMappingInterceptor,
  provideScreenSizeVars
} from "@mindpath/shared";
import {LoadConfig, provideConfig} from "../config";
import {NgxPiwikProModule, NgxPiwikProRouterModule} from "@piwikpro/ngx-piwik-pro";
import {AuthService} from "./auth";
import {InitializeSentry, SentryService} from "./analytics/sentry";
import {sentryTracePropagationInterceptor} from "./analytics/sentry/sentry-trace-propagation.interceptor";
import {providePrimeNG} from "primeng/config";
import Aura from '@primeng/themes/aura';
import {OverrideScreenBreakpoints} from "./setup/breakpoint-overrides";
import {withPiwikHeaderInterceptor} from "./analytics/piwik";
import {statusCodeRetryInterceptor} from "./networking/status-code-retry.interceptor";
import {tokenInjectionInterceptor} from "./auth/token-injection.interceptor";


export async function getAppConfig() {
  const moduleProviders: ImportProvidersSource[] = [];
  const config = await LoadConfig();

  if (config.isProduction) {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    console.debug = () => {};
  }

  if (config.piwik) {
    moduleProviders.push(NgxPiwikProModule.forRoot(config.piwik.siteId, config.piwik.url));
    moduleProviders.push(NgxPiwikProRouterModule);
  }
  OverrideScreenBreakpoints();
  InitializeSentry(config);

  return  {
    providers: [
      // provideZoneChangeDetection({ eventCoalescing: true }),
      provideZonelessChangeDetection(),
      // No animations provider on purpose. Nothing uses the trigger() DSL any more (the dimmer
      // moved to animate.enter / animate.leave), and providing one replaces RendererFactory2 with
      // the animation factory, whose removeChild() defers to an engine flushed only at the end of
      // a change-detection cycle. In a zoneless app a Renderer2 call made from a raw DOM listener
      // then never lands -- which is exactly how PrimeNG's drawer mask became permanent on
      // the results page. Leaving RendererFactory2 alone removes that whole class of hazard.
      providePrimeNG({
        theme: {
          preset: Aura,
          options: {
            darkModeSelector: '.my-app-dark',
            cssLayer: true,
          }
        }
      }),
      provideConfig(),

      AuthService.provideUser(),

      provideEnvironmentNgxMask(),
      provideHttpClient(
        withFetch(),
        withInterceptors([
          sentryTracePropagationInterceptor,
          httpErrorMappingInterceptor,
          statusCodeRetryInterceptor,
          tokenInjectionInterceptor,
          withPiwikHeaderInterceptor
        ])
      ),
      provideScreenSizeVars(),
      provideRouter(routes),
      importProvidersFrom(moduleProviders),
      SentryService.provideTracking(),
    ]
  } satisfies ApplicationConfig;

}

